export type AppIntegrationVisibility = "TEAM" | "PERSONAL";

export type ProtoVisibility = "team" | "personal";

export function isTeamVisibility(
  visibility: AppIntegrationVisibility | undefined | null
): boolean {
  return visibility === "TEAM";
}

export function apiVisibilityToProto(
  visibility: AppIntegrationVisibility | undefined | null
): ProtoVisibility {
  return visibility === "TEAM" ? "team" : "personal";
}

export function protoVisibilityToApi(
  visibility: ProtoVisibility
): AppIntegrationVisibility {
  return visibility === "team" ? "TEAM" : "PERSONAL";
}
